// ----------------------------------------------------------------------

const fr = {

  chatService: {
    french: "français",
    english: "anglais",
    spanish: "espagnol",
    german: "allemand"
  },

  home: {
    welcome: "Bienvenue dans votre centre d'administration Click-To-Connect",
    unify: "Unifiez les communications avec vos clients via  votre site Web et WhatsApp",
    empower: "Permettez à vos agents de communiquer instantanément avec vos clients, qu'ils vous contactent via votre site Web ou WhatsApp.",
    support: "Communication multicanale fluide:",
    rainbow: "Avec Rainbow Click-To-Connect, toutes les demandes provenant du Web ou de WhatsApp sont acheminées vers votre équipe d'agents Rainbow, garantissant ainsi qu'aucun message n'est manqué et que chaque client se sent écouté.",
    website: "Canal  site Web actif: ",
    communication: "Transformez votre site Web en un centre de communication dynamique et bidirectionnel par conversation, audio ou vidéo.",
    whatsapp: "Canal WhatsApp:",
    business: "Augmentez votre accessibilité auprès des clients en activant votre canal de communication WhatsApp Business.",
    resources: "Ressources d'administration C2C: "
  },
  dashboard: {
    welcome: "Bienvenue sur le centre d'administration Click-To-Connect",
    construction: "Le Dashboard est en construction"
  },
  skills: {
    global: {
      title: "Paramètres généraux des règles de routage",
      maxNbrOfChats: "Nombre maximum de discussions",
      adminGroupName: "Nom du groupe Admin",
      bubbleTTL: "TTL de la Bulle en secondes",
      alertMessage: "Message d'alerte",
      discardPresence: "Ne pas prendre en comtpe la préscence",
      availableOnMobile: "Disponible sur mobile (état de la presence)",
      pop1: "Nombre maximum de discussions qu'un agent peut gérer. Il est considéré comme occupé s'il atteint ce niveau",
      pop2: "Nom du groupe administrateur dans la liste de contacts. Les membres de ce groupe reçoivent un rapport chaque jour",
      pop3: "Chaque nuit, les anciennes bulles sont supprimées. Les anciennes bulles désignent les bulles plus anciennes que ce niveau en secondes. 172800 secondes équivaut à 2 jours",
      pop4: "Définissez le message de bienvenue sur Important. L'agent est averti par un son d'alerte",
      pop5: "Ne tenez pas compte de la présence dans la sélection des agents. L'agent est sélectionné même s'il est au téléphone, absent, en réunion, avec un nombre maximum de chats... mais pas hors ligne",
      pop6: "Considérez la présence mobile de l'agent comme disponible"
    },
    skills: {
      title: "Management des Domaines & Sujets",
      addSkillBtn: "+ Ajouter un nouveau Domaine",
      formAddSkillBtn: "Ajouter à la liste",
      formAddSkillTitle: "Créer un nouveau Domaine",
      formSkillName: "Nom du Domaine",
      formDescription: "Description",
      addGroupBtn: "Ajouter un nouveau Sujet",
      formGroupBtn: "Ajouter à la liste",
      formGroupTitle: "Créer un nouveau Sujet",
      formGroupName: "Nom du Sujet",
      formGroupNameExist: "Ex: solutions",
      formGroupFormValueEnglish: "Valeur anglaise dans le formulaire",
      formGroupFormValueFrench: "Valeur française dans le formulaire",
      formGroupFormValueSpanish: "Valeur espagnole dans le formulaire",
      formGroupFormValueGerman: "Valeur allemande dans le formulaire",
      formGroupFormValueChinese: "Valeur chinoise dans le formulaire",
      formGroupFormValueExist: "Valeur",
      formGroupTelNumber: "Numéro telephonique",
      formGroupTelExist: "Juste des caractères digitaux",
      formGroupBot: "Bot Sujet",
      cancelBtn: "- Annuler",
      cancelBtn2: "Annuler",
      pop1: "Pour qu'un sujet soit prit en compte via l'URL de connection, son nom ne doit pas contenir de majuscules ou caractères spéciaux; 20 caractères max"
    },
    groups: {
      domain: "Domaine",
      subject: "Sujet",
      toolbarBackBtn: "Retour aux Domaines & Sujets",
      formGroupBtn: "Editer le Sujet",
      formGroupBtn3: "Sauvegarder",
      formGroupName: "Nom du Sujet",
      formGroupBtn2: "Mettre à jour le sujet",
      formGroupNameExist: "Ex: solutions",
      formGroupFormValueEnglish: "Valeur anglaise dans le formulaire",
      formGroupFormValueFrench: "Valeur française dans le formulaire",
      formGroupFormValueSpanish: "Valeur espagnole dans le formulaire",
      formGroupFormValueGerman: "Valeur allemande dans le formulaire",
      formGroupFormValueChinese: "Valeur chinoise dans le formulaire",
      formGroupFormValueExist: "Valeur",
      formGroupTelNumber: "Numéro telephonique",
      formGroupTelExist: "Juste des caractères digitaux",
      formGroupBot: "Bot Sujet",
      sideInfosType: "Type du Sujet",
      sideInfosCreationDate: "Date de création",
      sideInfosEditionDate: "Date de modification",
      cancelBtn2: "Annuler",
      sideAgentsTitle: "Agents",
      sideAgentsNoAgent: "Il n'y a pas encore d'agents dans ce Sujet",
      addAgentsBtn: "Assigner des agents",
      formAgentsBtn: "Ajouter à la liste",
      formAgentsName: "Assigner des agents au Sujet"
    },
    agents: {
      title: "Management des agents",
      inviteAgentBtn: "+ Inviter un agent",
      cancelBtn: "- Annuler",
      formMessage: "Pour inviter un nouvel agent, veuillez saisir son adresse e-mail ci-dessous",
      sendBtn: "Envoyer"
    }
  },
  interface: {
    global: {
      title: "Gestion globale de l'UI",
      primaryColor: "Couleur primaire",
      languages: "Languages",
      english: "Anglais",
      french: "Français",
      german: "Allemand",
      spanish: "Espagnol",
      chinese: "Chinois",
      defaultLanguage: "Language par défaut",
      redirectUrl: "URL de redirection",
      guestLeftMessage: "Guest left message",
      otherOptions: "Autres options",
      pop1: "Liste des languages pris en compte",
      pop2: "Langue utilisée par défaut si la langue captée par le frontend n'est pas prit en compte dans la liste au dessus",
      pop3: "Adresse de la page à consulter en cas d'absence d'agent disponible",
      pop4: "Message envoyé à l'agent quand le guest quitte la conference",
      pop5: "Permet une réponse automatique. Aucune popup ne s'affiche. L'invité entre automatiquement dans la conférence",
      pop6: "Démarre l'appel avec audio et vidéo"
    },
    form: {
      title: "Configuration du Formulaire Web",
      imageMsg: "Déposez votre image ici ou cliquez pour sélectionnez une image (just des .png, .jpg and .jpeg)",
      titleColor: "Texte d'introduction",
      buttonColor: "Text du button",
      messageColor: "Couleur du texte d'introduction du formulaire",
      field: 'Champ',
      fieldsTitle: "Champs",
      fieldsValueEnglish: "Anglais: ",
      fieldsValueFrench: "Français: ",
      fieldsValueSpanish: "Allemand: ",
      fieldsValueGerman: "Espagnol: ",
      fieldsValueChinese: "Chinois: ",
      addFieldBtn: "Ajouter un nouveau champ",
      addItemBtn: "Ajouter un item",
      addFieldName: "ID du champ",
      addFieldId: 'ID de la liste',
      addItemId: "ID de l'item",
      addFieldExist: "Ex: firstname",
      addFieldValueEnglish: "Valeur anglaise dans le formulaire",
      addFieldValueFrench: "Valeur française dans le formulaire",
      addFieldValueSpanish: "Valeur espagnole dans le formulaire",
      addFieldValueGerman: "Valeur allemande dans le formulaire",
      addFieldValueChinese: "Valeur chinoise dans le formulaire",
      addFieldValueExist: "Valeur",
      addBtn: "Ajouter à la liste",
      typeBtn: "TYPE DE CHAMPS",
      sizeBtn: "TYPE",
      UpdateBtn: "Mettre à jour le champ",
      deletetn: "Effacer",
      cancelBtn: "Annuler",
      cropCancelBtn: "Annuler",
      cropValidateBtn: 'Crop',
      liveMessage1: "Merci de répondre aux questions suivantes",
      liveMessage2: "- J'accepte et envoie ma demande -",
      pop1: "Couleur du message"
    },
    chat: {
      title: "Configuration du Chat et de la Video",
      imageMsg: "Déposez votre image ici ou cliquez pour sélectionnez une image (just des .png, .jpg and .jpeg)",
      customMessages: "Messages custom",
      otherOptions: "Autres options",
      formTitleMessage: "Titre",
      formBtnMessage: "Bouton",
      welcomeMessageTitle: "Message de bienvenue",
      endMessageTitle: "Message de fin de conversation",
      guestLeftMessageTitle: "Message pour l'agent quand le client a quitté la conversation",
      topBarColorTitle: "Barre superieure",
      agentMessageBGC: "Fond de l'agent",
      userMessageBGC: "Fond de l'utilisateur",
      agentMessageTxtColor: "Texte de l'agent",
      userMessageTextColor: "Texte de l'utilisateur",
      hyperlinkMessagesTextColor: "Hyperlink",
      userMessage: "Bonjour",
      english: "Anglais",
      french: "Français",
      german: "Allemand",
      spanish: "Espagnol",
      chinese: "Chinois",
      pop1: "Couleur de la barre supérieure",
      pop2: "Couleur de fond des messages de l'agent du bot dans le chat",
      pop3: "Couleur de fond des messages de l'utilisateur dans le chat",
      pop4: "Couleur du texte de l'agent",
      pop5: "Couleur du texte de l'utilisateur dans le chat",
      pop6: "Couleur des liens hyperlink dans le chat",
      pop7: "Utiliser la caméra arrière par défaut pour les mobiles ou les tablettes",
      pop8: "Afficher l'icône pour basculer entre les vues de messagerie instantanée et vidéo",
      pop9: "Utiliser le partage d'écran sur le bureau"
    }
  },
  settingsV2: {
    whatsapp: {
      loading: "Chargement...",
      metaApp: "Application Meta",
      appID: "APP ID : ",
      reconnectBtn: "Reconnexion",
      reconnectPop: "Votre session Meta WhatsApp Click-To-Connect a expirée, veuillez réinitialiser votre session en vous reconnectant à votre compte Meta.",
      disconnectBtn: "Réinitialisation",
      disconnectPop: "Réinitialisez les paramètres de votre application WhatsApp Business",
      disconnectMessage: "Vous êtes sur le point de réinitialiser les paramètres de votre compte WhatsApp Business. Vous confirmez ?",
      yesBtn: "Oui",
      noBtn: "Non",
      rainbowConversations: "Conversations Rainbow",
      cleanBtn: "Clean",
      limitHeader: "20 caractères maximum",
      limitBody: "1024 caractères maximum",
      limitButton: "20 caractères maximum",
      waSettings: "Paramètres Whatsapp",
      formCredentials: "Formulaire d'authentification",
      userId: "App Id",
      password: "Clé secret de l'App",
      tempToken: "Token d'accès temporaire",
      register: "Enregistrement",
      messCustom: "Messages customisés",
      welcomeTitle: "Titre accueil",
      skillsGroupsBody: "Texte sélection du Domaine",
      skillsGroupsTitle: "Nom de la liste des Domaines",
      agentsGroupsBody: "Texte sélection du Sujet",
      agentsGroupsTitle: "Nom de la liste des Sujets",
      reasonsButton: "Libellé du bouton de sélection",
      connectingAgent: "Connexion avec un agent",
      connectedAgent: "Connecté avec un agent",
      convTerminated: "Conversation terminée",
      noAgentMessage: "Message 'Aucun agent disponible'"
    },
    telephony: {
      title: "Paramètres de la Telephonie",
      pbxID: "PBX ID",
      ranges: "Plages",
      defaultNumber: "Numéro par defaut",
      pop1: "PBX ID",
      pop2: "Plages de numéros REX disponibles. Le format est startRange1:endRange1,startRange2:endRange2. Exemple : 3300:3400,3500:3550",
      pop3: "Numéro par défaut utilisé (/?telephony=true)"
    },
    sms: {
      title: "Paramètre des SMS",
      roomName: "Nom de la Room",
      smsText: "Message d'invitation",
      pop1: "text + numéro de téléphone du client",
      pop2: "text + link",
      noConfig: "Vous avez besoin d'une licence RVA Expert pour cette fonctionnalité..."
    },
    routing: {
      title: "Routage externe",
      noRoutes: "Aucune route n'a encore été enregistrée",
      addRouteBtn: "Ajouter une nouvelle route",
      routeNameExist: "Nom de la route",
      routePathExist: "Chemin de la route",
      addToTheListBtn: "Ajouter à la liste",
      cancelBtn: "Annuler"
    },
    tasks: {
      title: "Paramètres des tâches",
      agentsAndBubblesSync: "Synchronization des Agents et des Bubbles",
      cleanOldBubbles: "Nettoyage des anciennes Bubbles",
      scrapping: "Scrapping (sondage de la disponibilité des agents)",
      report: "Envoyer un rapport quotidien via des tickets"
    }
  },
  menuLeft: {
    dashboard: "Accueil",
    skills: "Règles de routage",
    skillsAndGroups: "Domaines & Sujets",
    generalSettings: "Paramètres généraux",
    userInterface: "Interface Utilisateur",
    form: "Formulaire"
  },
  general: {
    saveBtn: "Sauvegarder les changements",
    settingsTitle: "Paramètres",
    telephony: "Telephonie",
    sms: "SMS",
    routing: "Routage externe",
    tasks: "Tâches"
  },
  snackbars: {
    getDataError: "Données non récupérées",
    sendDataError: "Configuration non sauvegardée",
    sendDataSuccess: "Configuration sauvegardée"
  },
  regex: {
    digit: "Le champ ne doit contenir que des chiffres",
    regSGMsg: "Un chiffre ne peut pas commencer par 0, il faut au moins 3 caractères et les espaces, les majuscules et les caractères spéciaux sont interdits",
    regNumberMsg: "3 caractères numériques minimum",
    regSpaceMsg: "Les espaces seuls ou en début de chaine sont interdis",
    regUrlMsg: "Vous devez entrer une URL valide",
    regCronMsg: "Seules les expressions cron à 6 valeurs sont autorisées",
    regRangesMsg: "Le format autorisé est le suivant : 1111:1120.",
    regPBXMsg: "Le format autorisé est le suivant : PBXeah3-j2dd-8ab9-4c60-89a1-fc6d-bb91-6x2f."
  },














  login: {
    welcome: 'Bonjour, bon retour',
    message: "Rainbow",
    button: 'Login avec Rainbow',
    tokenExpired: 'La session a expiré. Vous devez vous reconnecter.',
    tooltip: 'Connectez-vous avec Rainbow pour pouvoir exporter vos enregistrements.'
  },
  nav: {
    home: 'Accueil',
    settings: 'Réglages',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    analytics : `Tableau de bord`,
    exporter : `Enregistrements`,
    cdr : 'CDR'
  },
  analytics: {
    welcomeMessage : `Bon retour sur le Rainbow Exporter`,
    widgets: {
      monthlyExport: 'Export Mensuel (enregistrements)',
      weeklyExport: 'Export Hebdomadaire (enregistrements)',
      dailyExport: 'Export Journalier (enregistrements)',
      thanLastMonth: 'que le mois dernier',
      thanLastWeek: 'que la semaine dernière',
      thanLastDay: 'que le jour dernier',
      noEvoForMonth: 'aucune évolution depuis le mois dernier',
      noEvoForWeek: 'aucune évolution depuis la semaine dernière',
      noEvoForDay: 'aucune évolution depuis hier',
      exportState: 'Status',
      exported: "Exporté",
      pending: 'En attente',
      new: 'Nouveau',
      failed: 'Echec', 
      exportToStorage: 'Traffic (enregistrements)',
      exportOn: 'exporté sur',
      files: 'fichiers',
      exportTimelineRecs: 'Historique des enregistrements',
      exportTimelineCDRs: 'Historique des CDR',
      recordDateTypo: "Enregistrement : ",
      exportDateTypo: "Export : ",
      billingPeriod: "Période : ",
      exportMethod: "Méthode : ",
      exportDest: "Destination : ",
      statusAllType: "Tout",
      statusRecsType: "Enregistrements",
      statusCDRsType: "CDR"
    }
  },
  exporter: {
    title: "Enregistrements",
    update: 'Rafraichir les données',
    updateTooltip: 'Mettre à jour la liste des enregistrements',
    all: 'Tout',
    exported: 'Exporté',
    pending: 'En attente',
    failed: 'Echec',
    recordDate: 'Date',
    exportDate: 'Exporté le',
    startDate: 'Date de départ',
    endDate: 'Date de fin',
    searchInfo: "Recherche d'un utilisateur ou d'un enregistrement...",
    user: 'Utilisateur',
    fileName: 'Enregistrement',
    size: 'Taille',
    state: 'Statut',
    exporting: 'Export en cours...',
    exportDone: 'Export effectué',
    exportButtonTooltip: 'Export sur ',
    selected: 'sélectionné(s)',
    clear: 'nettoyer',
    exportFail: 'Un ou plusieurs enregistrements ont déjà été exportés',
    dateType: "Type de date",
    exportedState: "Exporté",
    failedState: "Echec",
    newState: "Nouveau",
    pendingState: "En attente",
    noChange: 'Aucun changement...',
    okChange: "Update réussie",
    exportFailed: "Une erreur s'est produite pendant l'export",
    fetchFailed: "Une erreur s'est produite pendant l'import",
    alreadyExported: "Un ou plusieurs Recordings avaient déjà été exportés et n'ont donc pas été dupliqués vers cette destination : ",
    okExported: "Tous les Recordings ont bien été exportés vers cette destination : ",
    noExisted: "Erreur pendant l'export : Un ou plusieurs Recordings n'existent pas : ",
    driveError: "Erreur pendant l'export : Il y a un problème avec cette destination : ",
    lastLabelOn: "Destination des exports pour vos enregistrements : ",
    lastLabelOff: "Aucune destination n'a encore été enregistrée pour l'export de vos enregistrements",
    new: 'Nouveau',
    noValidIds: "Certains enregistrements n'ont pas d'ID valide",
    noValidId: "Un enregistrement n'a pas d'ID valide",
    noExistIds: "Certains enregistrements n'existent pas",
    noExistId: "Un enregistrement n'existe pas",
    alreadyExportedIds: "Certains enregistrements ont déjà été exportés",
    alreadyExportedId: "Un enregistrement a déjà été exporté",
    pendingIds: "Des enregistrements sont en cours d'export",
    pendingId: "Un enregistrement est en cours d'export",
    error: "Une erreur est surevenue lors de l'export d'enregistrement(s)",
    downloadRecordFailed: "Une erreur s'est produite pendant le téléchargement de l'enregistrement en local"
  },
  cdr: {
    title: "CDR",
    update: 'Rafraichir les données',
    updateTooltip: 'Mettre à jour la liste des CDR',
    startDate: 'Date de départ',
    endDate: 'Date de fin',
    creationDate: 'Date de création',
    billingDate: 'Période de facturation',
    searchInfo: "Recherche d'un CDR...",
    fileName: 'CDR',
    downloadDone: 'Téléchargement effectué avec succès',
    downloadButtonTooltip: 'Téléchargement en local',
    selected: 'sélectionné(s)',
    clear: 'nettoyer',
    dateType: "Type de date",
    noChange: 'Aucun changement...',
    okChange: "Update réussie",
    downloadCDRFailed: "Une erreur s'est produite pendant le téléchargement du CDR en local",
    fetchFailed: "Une erreur s'est produite pendant l'import",
    alreadyExported: "Un ou plusieurs CDR avaient déjà été exportés et n'ont donc pas été dupliqués vers cette destination : ",
    okExported: "Tous les CDR ont bien été exportés vers cette destination : ",
    noExisted: "Erreur pendant l'export : Un ou plusieurs CDR n'existent pas : ",
    driveError: "Erreur pendant l'export : Il y a un problème avec cette destination : ",
    lastLabelOn: "Destination des exports pour vos CDR : ",
    lastLabelOff: "Aucune destination n'a encore été enregistrée pour l'export de vos CDR",
    new: 'Nouveau',
    noValidIds: "Certains cdrs n'ont pas d'ID valide",
    noValidId: "Un cdr n'a pas d'ID valide",
    noExistIds: "Certains cdrs n'existent pas",
    noExistId: "Un cdr n'existe pas",
    alreadyExportedIds: "Certains cdrs ont déjà été exportés",
    alreadyExportedId: "Un cdr a déjà été exporté",
    pendingIds: "Des cdrs sont en cours d'export",
    pendingId: "Un cdr est en cours d'export",
    error: "Une erreur est surevenue lors de l'export de cdr(s)"
  },
  settings: {
    title: 'Réglages',
    updateSucces: 'Update réussie',
    updateFail: 'Update échouée',
    googleDriveId: "Google Drive ID",
    googleDriveHelp: "Partager l'id du dossier de votre Google Drive pour y exporter vos enregistrements",
    googleDriveCurrent: 'Actuel id du Google Drive :',
    idAlreadyExist: "Cet ID est déjà enregistré",
    saveBtn: 'Sauvegarder les changements',
    emailLink: "Email",
    emailType: "Type d'Email",
    emailAlreadyExist: "Cet Email existe déjà dans la liste",
    frequenceTitle: "Fréquence des notifications",
    frequency: "Fréquence",
    actualFrequency: "Fréquence actuelle :",
    emailsList: "Liste d'emails",
    noEmail: "Aucun Email n'a encore été renseigné",
    addEmail: "Ajouter un Email à la liste",
    badEmail: "Email invalide",
    required: 'Obligatoire',
    deleteBtn: "Effacer",
    AbortBtn: "Annuler",
    addEmailBtn: "Ajouter un Email",
    never: "jamais",
    daily: "journalière",
    weekly: "hebdomadaire",
    monthly: "mensuelle",
    enable: "Activer",
    disable: "Désactiver",
    required: 'Requis',
    configAlreadyExist: "Cette configuration existe déjà",
    recsDestination: "Destination des enregistrements",
    cdrDestination: "Destination des CDR",
    exportActivation : "Automatisation des exports",
    driveSelection : "Selection de la destination",
    actualState: "Etat actuel :",
    actualDrive: "Destination actuelle :",
    active: "Actif",
    inactive: "Inactif",
    noDestination: "Aucune destination n'a encore été enregistrée",
    driveAlreadyExist: "Ce drive a déjà été enregistré",
    sftpList: "Liste des drives SFTP",
    noDriveSFTP: "Il n'y a aucun drive SFTP enregistré",
    addDrive: "Ajouter un drive à la liste",
    labelName: "Nom",
    helperName: "Un nom pour votre Drive",
    labelUrl: "Domain/IP SFTP",
    helperUrl: "Le domain ou IP de destination pour vos exports",
    labelPath: "Chemin SFTP",
    helperPath: "Le dossier de destination (ex: nomDuChemin)",
    labelLogin: "Utilisateur SFTP",
    helperLogin: "L'utilisateur pour se connecter à l'url SFTP",
    labelPass: "Mot de passe SFTP",
    helperPass: "Le mot de passe pour se connecter à l'url SFTP",
    addDrivePlus: "Ajouter un drive",
    cancel: "Annuler",
    noDriveGoogle: "Il n'y a aucun drive Google enregistré",
    googleList: "Liste des drives Google",
    googleId: "ID du dossier",
    autoLabel: "Destinations & Automatisation",
    lastSyncWithRainbow: "Dernière syncronisation avec Rainbow:",
    mini2Dest: "Vous devez renseigner au moins 2 destinations",
    noFieldSelected: "Aucun champ n'a été sélectionné",
    drivesList: "Liste des drives",
    noDrivesOnSettings: "Aucun drive n'est enregistré",
    driveTypeSelection: "Sélectionner un type de drive"
  },
  page404: {
    home: "Accueil",
    contact: 'Nous contacter',
    login: 'Login',
    notFoundSorry: "Désolé, page introuvable !",
    notFoundMessage: "Nous n'avons pas trouvé la page que vous recherchez.",
    networkIssue: "Il y a un problème de réseau, veuillez nous contacter.",
    urlMistyped: "Peut-être avez-vous mal saisi l'URL ? Assurez-vous de vérifier votre orthographe."
  },
  page401: {
    home: "Accueil",
    contact: 'Nous contacter',
    login: 'Login',
    inaccessibleSorry: "Désolé, page inaccessible !",
    unauthorizedMessage: "Vous n'êtes pas authorisé à consulter cette application.",
    requestIssue: "La requête a échouée avec un code 401."
  },
  noServer: {
    home: "Accueil",
    contact: 'Nous contacter',
    login: 'Login',
    inaccessibleSorry: "Désolé, page inaccessible !",
    noServerMessage: "Le server ne répond pas.",
    requestIssue: "La requête a été envoyée mais aucune réponse n’a été reçue.",
    reconnect: "Le server est offline, nous tentons une reconnection",
    logout: "Echec de la reconnection au server, veuillez réessayer plus tard",
    offline: "Le server est offline, veuillez réessayer plus tard",
    badApi: "L'adresse de l'API n'est pas valide"
  },
  error: {
    responseType: "La requête a été envoyée mais la réponse du serveur contient un code d'erreur.",
    requestType: "La requête a été envoyée mais aucune réponse n’a été reçue du server.",
    otherType: "Il y a eu une erreur lors la construction de la requête."
  },
  noData: {
    records: "Il n'y a aucun enregistrement",
    cdr: "Il n'y a aucun CDR"
  }
};

export default fr;
